/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';

import { ChevronRight } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Slide, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Toolbar from '@mui/material/Toolbar';
import { TransitionProps } from '@mui/material/transitions';

import { useAppDispatch } from 'state/hooks';
import { setRMCreateRouteModal } from 'state/routeMonitoringSlice';
import { setMaximize } from 'state/workflowSlice';

import { Map } from 'features/map/Map';
import { withSegmentTooltip } from 'features/map/hooks/withSegmentTooltip';
import { TaskBar } from 'features/task_bar/TaskBar';
import { RouteInstructionsPanel } from 'features/workflow_common/RouteInstructions/RouteInstructions';
import { WorkflowNrtSkeleton } from 'features/workflow_nrt/WorkflowRecent';
import { MaximizeOnlyButton } from 'features/workspace/MaximizeButton';

import { MAXIMIZE_MAP } from '../../../appConstants';
import { ReactComponent as StlConLogo } from '../../app_header/streetlight_logo.svg';

import styles from './AddRouteModal.module.css';

const Transition = React.forwardRef<
  unknown,
  TransitionProps & { children: React.ReactElement }
>((props, ref) => <Slide direction="up" ref={ref} {...props} />);

function ModalMap(props) {
  return (
    <Map chartShowhide={false} {...props} extras={<MaximizeOnlyButton />} />
  );
}

const MapWithTooltip = withSegmentTooltip(ModalMap);

export function AddRouteModal({ open }: { open: boolean }) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (open) dispatch(setMaximize(null));
  }, [open]);

  const handleClose = () => {
    dispatch(setRMCreateRouteModal(false));
    dispatch(setMaximize(MAXIMIZE_MAP));
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <Toolbar className={styles.toolbar}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <StlConLogo alt="streetlight_logo" />
          <Typography variant="body1" fontWeight={500}>
            Route Monitoring
          </Typography>
          <ChevronRight fontSize="small" />
          <Typography variant="body1" fontWeight={500}>
            Add New Route
          </Typography>
        </Box>
        <IconButton edge="end" onClick={handleClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Toolbar>
      {open && (
        <WorkflowNrtSkeleton
          enableScreenshot={false}
          vizRegionComponent={
            <RouteInstructionsPanel
              sx={{ maxWidth: '100%' }}
              closeBtn
              maximizeBtn={false}
            />
          }
          mapComponent={<MapWithTooltip enableRouteSelection />}
          taskBarComponent={
            <TaskBar savedRoutes="modal" showTitle={false} ignoreHideSidebar />
          }
        />
      )}
    </Dialog>
  );
}
